import { render } from "./CMultiSelect.vue?vue&type=template&id=f71188a2"
import script from "./CMultiSelect.vue?vue&type=script&lang=js"
export * from "./CMultiSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__